export enum CheckBoxGroupDirection {
  Horizontal,
  Vertical,
}
